import React from "react";
import { Col, Card, Button, Modal, Input } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import Notes from "./Notes";

const { TextArea } = Input;

export const NotesCard = React.memo(
	({
		player,
		notes,
		updateNotes,
		isModalVisible,
		newNote,
		loading,
		showModal,
		handleCancel,
		handleSubmit,
		handleEditNoteClick,
		handleDeleteClick,
		setNewNote,
		handleSubmitEdit,
		noteIdToEdit
	}) => {
		
		return (
			<Col>
				<Card
					title={
						<div
							style={{
								width: "100%",
								textAlign: "center",
								position: "relative",
							}}
						>
							Notes
						</div>
					}
					style={{ 
						width: "100%", 
						height: '14.75rem'
					}}
					bodyStyle={{
						padding: "1rem",
						height: "11.125rem",
						overflow: "overlay",
						backgroundColor: "#fafafa",
					}}
					headStyle={{
						height: "3rem",
						padding: "0 .5rem",
						display: "flex",
						justifyContent: "center",
						position: "relative",
					}}
					extra={
						<Button
							type="primary"
							shape="circle"
							icon={<PlusOutlined />}
							onClick={showModal}
							aria-label="Add new note"
							style={{
								position: "absolute",
								right: "1rem",
								top: "50%",
								transform: "translateY(-50%)",
							}}
						/>
					}
				>
					{player && notes && (
						<Notes
							player={player}
							notes={notes}
							updateNotes={updateNotes}
							handleEditNoteClick={handleEditNoteClick}
							handleDeleteClick={handleDeleteClick}
						/>
					)}
				</Card>
				<Modal
					title={typeof noteIdToEdit === "number" && noteIdToEdit >= 0 ? "Edit note" : "Add New Note"}
					open={isModalVisible}
					onOk={typeof noteIdToEdit === "number" && noteIdToEdit >= 0 ? handleSubmitEdit : handleSubmit}
					onCancel={handleCancel}
					confirmLoading={loading}
				>
					<TextArea
						rows={4}
						value={newNote}
						onChange={(e) => setNewNote(e.target.value)}
						placeholder="Enter your note here"
					/>
				</Modal>
			</Col>
		)
	}
);
